// components/ui/BackgroundDecoration.tsx
import React from "react";
import { Baby, Heart, Stethoscope, Shield } from "lucide-react";

export const BackgroundDecoration: React.FC = () => {
  const icons = [Baby, Heart, Stethoscope, Shield];
  const colors = [
    "text-blue-200",
    "text-cyan-200", 
    "text-indigo-200",
    "text-sky-200",
  ];

  return (
    <div className="fixed inset-0 overflow-hidden pointer-events-none">
      {[...Array(8)].map((_, i) => {
        const Icon = icons[i % icons.length];
        const colorClass = colors[i % colors.length];

        return (
          <div
            key={i}
            className={`absolute ${colorClass} opacity-20 animate-float`}
            style={{
              top: `${Math.random() * 80 + 10}%`,
              left: `${Math.random() * 80 + 10}%`,
              animationDelay: `${Math.random() * 5}s`,
            }}
          >
            <Icon className="w-5 h-5" />
          </div>
        );
      })}
    </div>
  );
};